import { useState, useEffect } from "react";
import useMediaQuery from "./useMediaQuery";
import * as Const from "../_Const";

export default function useTvType() {
  const [screenType, setScreenType] = useState(Const.SCREEN_UNKNOWN);
  //mam 3 velikosti obrazovek pro info panel
  //1280x720 HD
  //1366x768 HD
  //1920x1080 Full HD
  //3840x2160 4K

  const sc720 = useMediaQuery("(min-height: 720px)");
  const sc768 = useMediaQuery("(min-height: 768px)");
  const sc1080 = useMediaQuery("(min-height: 1080px)");
  const sc2160 = useMediaQuery("(min-height: 2160px)");

  let screenVal = Const.SCREEN_UNKNOWN;
  if (Const.isTerminal()) {
    if (sc2160) {
      screenVal = Const.SCREEN_TV_2160;
    } else if (sc1080) {
      screenVal = Const.SCREEN_TV_1080;
    } else if (sc768) {
      screenVal = Const.SCREEN_TV_768;
    } else if (sc720) {
      screenVal = Const.SCREEN_TV_720;
    }
  }

  useEffect(() => {
    setScreenType(screenVal);
    //console.log("set screen:", screenVal);
  }, [screenVal]);

  return screenType;
}
